// Feature spec 17, phase 7 (spec 11 6.15 item 38): a 409 `ORIGIN_DETACH_BLOCKED` in Settings → Network and the destroy
// dialog. A Google Cloud load balancer serves a route from the deployment's app, so the detach, the network change or the
// destroy waits until the route is removed and the network applied; each route links to its entry point.
import { CircleX } from 'lucide-react';
import { Link } from 'react-router';
import type { OriginDetachBlockedDetails } from '../../api/types';
import { strings } from '../../strings';
import { detachBlockedSentences } from './helpers';

const e = strings.networks.entryPoints;

export function OriginDetachBlockedCallout({
  details,
  message,
}: {
  details: OriginDetachBlockedDetails | null;
  /** The server's text, used when the details are missing. */
  message?: string | null;
}) {
  const sentences = details ? detachBlockedSentences(details) : [message ?? 'ORIGIN_DETACH_BLOCKED'];
  return (
    <div role="alert" className="callout callout-danger mb-3" data-testid="origin-detach-blocked">
      <CircleX aria-hidden className="size-4 shrink-0" />
      <div className="min-w-0 flex-1">
        <ul className="space-y-1">
          {sentences.map((text, i) => {
            const route = details?.routes[i];
            return (
              <li key={i}>
                {text}{' '}
                {details && route && (
                  <Link
                    className="link underline"
                    to={`/networks/${details.networkId}?tab=entry-points`}
                    data-testid={`origin-detach-blocked-link-${route.entryPointId}`}
                  >
                    {e.codes.openEntryPoint(route.entryPointId)}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
        <p className="mt-0.5 font-mono text-xs">ORIGIN_DETACH_BLOCKED</p>
      </div>
    </div>
  );
}
